import { FC } from "react";
import { IconProps } from "@/shared/types/icon";
import { Svg } from "@abel-technologies-as/components";

export const Export: FC<IconProps> = ({ width = "16", height = "16", color = "none", onClick, className }) => {
	return (
		<Svg width={width} height={height} viewBox="0 0 16 16" fill={color} className={className} onClick={onClick}>
			<path
				d="M7.99992 10.0833L7.99992 1.75M7.99992 10.0833C7.4164 10.0833 6.32619 8.42142 5.91659 8M7.99992 10.0833C8.58344 10.0833 9.67364 8.42142 10.0833 8M1.33325 11.75C1.33325 13.8183 1.76492 14.25 3.83325 14.25H12.1666C14.2349 14.25 14.6666 13.8183 14.6666 11.75"
				stroke="#344054"
				strokeWidth="1.66667"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Svg>
	);
};
